import React from "react"
import loadable from "@loadable/component"

export default {
  component: loadable(
    () => import(/* webpackChunkName: "DeliveryCharge" */ "./DeliveryCharge"),
    {
      fallback: <div>Loading...</div>,
    }
  )
}
